// @flow

// Effect Manager
import { fork, put, take } from 'redux-saga/effects'

// Constants
import {
  SHOW_IMPORT_JOBS_TOOL,
  SHOW_IMPORT_JOBS_POPUP,
} from '../constants'
import {
  PROP_SEASON_ID,
  PROP_FILES,
  PROP_WARNINGS,
} from 'hfty-model-import-jobs-tool'

import {
  PROP_IMPORT_RESULT_ID,
  PROP_ERRORS,
  PROP_IS_PARTIALLY_SUCCESSFUL_IMPORT,
} from 'hfty-model-import-jobs-popup'

// Operators
import seasonJobsOperator, { watchOperations as watchToolOperations } from 'hfty-operator-import-jobs-tool'
import seasonJobsPopupOperator, { watchOperations as watchPopupOperations } from 'hfty-operator-import-jobs-popup'

// Selectors
import { importJobsToolOperations$, importJobsPopupOperations$ } from 'hfty-soil-jobs-dom'

export default function *watchUploadOperations (): Generator<*, void, *> {
  while (true) {
    const { type, payload } = yield take([SHOW_IMPORT_JOBS_TOOL, SHOW_IMPORT_JOBS_POPUP])
    switch (type) {
      case SHOW_IMPORT_JOBS_TOOL:
        yield fork(watchToolOperations, {operations$: importJobsToolOperations$})
        yield fork(createSeasonJobsOperation)
        break
      case SHOW_IMPORT_JOBS_POPUP:
        yield fork(watchPopupOperations, {operations$: importJobsPopupOperations$})
        yield fork(createSeasonJobsPopupOperation, payload)
        break
    }
  }
}

export function *createSeasonJobsOperation (): Generator<*, void, *> {
  const operation = seasonJobsOperator.create({
    model: {
      [PROP_SEASON_ID]: null,
      [PROP_FILES]: [],
      [PROP_WARNINGS]: [],
    },
  })

  yield put(seasonJobsOperator.actionCreators.add(operation))
}

export function *createSeasonJobsPopupOperation (payload: Object): Generator<*, void, *> {
  const operation = seasonJobsPopupOperator.create({
    model: {
      [PROP_IMPORT_RESULT_ID]: null,
      [PROP_ERRORS]: payload.errors,
      [PROP_IS_PARTIALLY_SUCCESSFUL_IMPORT]: payload.isPartiallySuccessfulImport,
    },
  })

  yield put(seasonJobsPopupOperator.actionCreators.add(operation))
}
